export default function useDocumentTitle() {
	function changeDocumentTitle(title: string) {
		document.title = title;
	}

	return {
		changeDocumentTitle,
	};
}
